export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "less_than_5kg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Less than 5kg"])},
        "5_to_10kg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["5kg to 10kg"])},
        "10_to_20kg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["10kg to 20kg"])},
        "over_20kg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["20kg and more"])}
      },
      "de": {
        "less_than_5kg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Weniger 5kg"])},
        "5_to_10kg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["5kg bis 10kg"])},
        "10_to_20kg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["10kg bis 20kg"])},
        "over_20kg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["20kg und mehr"])}
      }
    }
  })
}